export default __webpack_public_path__ + "static/media/humongous.d16ea0c8.svg";